import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function CoachOnboardingGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#A3A3A3]"><div className="label-mono">Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "coach") return <Navigate to="/dashboard" replace />;
  if (user.must_change_password) return <Navigate to="/account/password" replace />;
  return children;
}
